import { IServiceFeeConfig } from '@modeso/types__dgoods-products';
import { ProductType } from '../enums/productType.enum';

export interface ProductSettingsDTO {
    productLineName: string;
    type: ProductType;
    couponsEnabled: boolean;
    displayOnIOS: boolean;
    displayOnAndroid: boolean;
    isGreyedOut: boolean;
    serviceFee: boolean;
    serviceFeeConfig?: IServiceFeeConfig;
}
